// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_1-akiru_akiru_module_ts":"2890ae9c46b7eb9e","src_app_2-about_about_module_ts":"7ad60e6329615596"}[chunkId] + ".js";
};